import * as React from 'react';
import { debounce } from 'debounce';
import commariser from '../../../lib/numbers/commariser';
import { i18n } from '../../../i18n';

const stripCommas = (x: string) => x.replace(/,/g, '');

interface AmountInputProps {
  lumpSum: number;
  monthlyContribution: number;
  setLumpSum: (x: number) => object;
  setMonthlyContribution: (x: number) => object;
}

interface AmountInputState {
  lumpSumText: string;
  monthlyContributionText: string;
}

export default class AmountInput extends React.Component<AmountInputProps, AmountInputState> {
  public state = {
    lumpSumText: '',
    monthlyContributionText: ''
  }

  public componentDidMount() {
    this.updateLumpSum = debounce(this.updateLumpSum, 500);
    this.updateMonthlyContribution = debounce(this.updateMonthlyContribution, 500);

    this.setState({
      lumpSumText: commariser(`${this.props.lumpSum}`),
      monthlyContributionText: commariser(`${this.props.monthlyContribution}`)
    });
  }

  public lumpSumAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const lumpSum = event.target.value ? stripCommas(event.target.value) : '';
    this.setState({ lumpSumText: commariser(lumpSum)});
    this.updateLumpSum(parseInt(stripCommas(event.target.value) || '0', 10));
  }

  public monthlyContributionAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const monthlyContribution = event.target.value ? stripCommas(event.target.value) : '';
    this.setState({ monthlyContributionText: commariser(monthlyContribution) });
    this.updateMonthlyContribution(parseInt(stripCommas(event.target.value) || '0', 10));
  }

  public updateLumpSum = (lumpSum: number) => {
    this.props.setLumpSum(lumpSum);
  }

  public updateMonthlyContribution = (monthlyContribution: number) => {
    this.props.setMonthlyContribution(monthlyContribution);
  }

  public render() {
    return (
      <div className='inv-amount-wrap'>
        <div className='input amount-input'>
          <h6>{i18n.t('tool.inv_amount.lump_sum')}</h6>
          <input type='text' onChange={this.lumpSumAmountChange} value={this.state.lumpSumText} placeholder='900,000' />
        </div>
        <div className='input amount-input'>
          <h6>{i18n.t('tool.inv_amount.monthly_payment')}</h6>
          <input type='text' onChange={this.monthlyContributionAmountChange} value={this.state.monthlyContributionText} placeholder='2,000' />
        </div>
      </div>
    );
  }
}
